module.exports = __webpack_public_path__ + "img/icon-cupo.2f44d84c.svg";